<template>
  <div class="p-4">
    <h1 class="text-2xl font-bold mb-4">Relación de Unidades</h1>
    <p>Vista en construcción...</p>
  </div>
</template>

<script>
export default {
  name: 'RelacióndeUnidades'
}
</script>
